import React from 'react';
import { CARD_ORDER, STATUS_META, fmtMoney } from './paymentUtils';

export const PaymentStatusCards = ({ stats, activeStatus, onSelect }) => {
  const byStatus = stats?.by_status || {};
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2" data-testid="payment-status-cards">
      {CARD_ORDER.map((key) => {
        const data = byStatus[key] || { count: 0, total: 0 };
        const active = activeStatus === key;
        return (
          <button
            key={key}
            type="button"
            data-testid={`payment-card-${key}`}
            onClick={() => onSelect(active ? '' : key)}
            className={`text-left px-3 py-2 rounded-lg border transition-shadow ${STATUS_META[key].card} ${
              active ? 'ring-2 ring-offset-1 ring-blue-500 shadow-sm' : 'hover:shadow-sm'
            }`}
          >
            <div className="text-lg font-bold" data-testid={`payment-card-count-${key}`}>{data.count}</div>
            <div className="text-xs font-medium">{STATUS_META[key].label}</div>
            <div className="text-[11px] opacity-70 truncate">{fmtMoney(data.total)}</div>
          </button>
        );
      })}
    </div>
  );
};
